module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr2.1cf2f1d.png";